export const POS_RH = { id: 'pos_rh', label: 'Rh+' };
export const NEG_RH = { id: 'neg_rh', label: 'Rh-' };
